import { render, staticRenderFns } from "./BookEnd.vue?vue&type=template&id=4dcefd72&scoped=true&"
import script from "./BookEnd.vue?vue&type=script&lang=js&"
export * from "./BookEnd.vue?vue&type=script&lang=js&"
import style0 from "./BookEnd.vue?vue&type=style&index=0&id=4dcefd72&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dcefd72",
  null
  
)

export default component.exports